import { jsx as _jsx } from "react/jsx-runtime";
// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './components/App.tsx';
import { createEditorFS } from './fs/filesystem.ts';
import { registerOpenSCADLanguage } from './language/openscad-register-language.ts';
import { zipArchives } from './fs/zip-archives.ts';
import { readStateFromFragment } from './state/fragment-state.ts';
import { createInitialState } from './state/initial-state.ts';
import './index.css';
import debug from 'debug';
import { registerCustomAppHeightCSSProperty } from './utils.ts';
import "primereact/resources/themes/lara-dark-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.min.css";
const log = debug('app:log');
if (process.env.NODE_ENV !== 'production') {
    debug.enable('*');
    log('Logging is enabled!');
}
else {
    debug.disable();
}
window.addEventListener('load', async () => {
    //*
    if (process.env.NODE_ENV === 'production') {
        if ('serviceWorker' in navigator) {
            try {
                const registration = await navigator.serviceWorker.register('./sw.js');
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
                registration.onupdatefound = () => {
                    const installingWorker = registration.installing;
                    if (installingWorker) {
                        installingWorker.onstatechange = () => {
                            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                // Reload to activate the service worker and apply caching
                                window.location.reload();
                                return;
                            }
                        };
                    }
                };
            }
            catch (err) {
                console.log('ServiceWorker registration failed: ', err);
            }
        }
    }
    //*/
    registerCustomAppHeightCSSProperty();
    const fs = await createEditorFS();
    await registerOpenSCADLanguage(fs, '/', zipArchives);
    // Nothing is persisted: the URL only ever names what to open (see
    // fragment-state.ts), and models live in /libraries, served from the site.
    const persistedState = await readStateFromFragment();
    const statePersister = { set: async () => { } };
    const initialState = createInitialState(persistedState);
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(React.StrictMode, { children: _jsx(App, { initialState: initialState, statePersister: statePersister, fs: fs }) }));
});
